import React from "react";
import { Link } from "react-router-dom";
import developer from "../../../../Assets/Images/course/classes.avif";

const MyClass = () => {
  return (
    <div className=" px-3 pb-3 max-xl:ml-10 max-xl:p-0">
      <div>
        <h3 className="mb-[28px] mt-5 leading-[38px]  max-sm:leading-[1.1428] color-[#000001] font-fira font-bold text-[20px] max-sm:text-[28px]">
          My Classes
        </h3>
        <div className="grid max-md:grid-cols-2 max-xl:grid-cols-3 gap-10">
          <div className="bg-[#fff]  shadow_custom  rounded-[15px]">
            <div className="">
              <img
                src={developer}
                className=" rounded-t-[15px]"
                alt="Global IT Master"
              />
            </div>
            <div className="p-3">
              <h3 className="text-[16px] font-fira font-semibold">
                Complete Web Development Course With MD Shahadat Hossain
              </h3>
              <Link to="/course-lesson-view">
                <button className="mt-8 mb-2 custom_button">
                  Continue Course
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyClass;
